module.exports = __webpack_public_path__ + "img/mc172.0277bb1c.jpg";